import type { AccordionListStrapiProps } from '@/components/molecules/accordion/AccordionListStrapi';
import { resolveContentBlock } from '@/components/molecules/accordion/accordionContent';

export const FAQ_SCHEMA_CONTEXT = 'https://schema.org';
export const FAQ_SCHEMA_PAGE_TYPE = 'FAQPage';
export const FAQ_SCHEMA_QUESTION_TYPE = 'Question';
export const FAQ_SCHEMA_ANSWER_TYPE = 'Answer';

type FAQContentNode = {
  text?: string;
  children?: FAQContentNode[];
};

interface FAQSchemaScriptProps {
  accordionList: AccordionListStrapiProps['accordionList'];
}

function normalizeText(value: string): string {
  return value
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function getContentText(content: FAQContentNode[] = []): string {
  return content
    .map((node): string => {
      if (node.text) return node.text;
      if (node.children) return getContentText(node.children);
      return '';
    })
    .join(' ');
}

function getAnswerText(
  item: AccordionListStrapiProps['accordionList'][number]
): string {
  const { text, text2 } = resolveContentBlock(item);

  return text2 ?? getContentText(text as FAQContentNode[]);
}

export default function FAQSchemaScript({
  accordionList,
}: FAQSchemaScriptProps) {
  return (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': FAQ_SCHEMA_CONTEXT,
          '@type': FAQ_SCHEMA_PAGE_TYPE,
          mainEntity: accordionList.map((item) => ({
            '@type': FAQ_SCHEMA_QUESTION_TYPE,
            name: normalizeText(item.header),
            acceptedAnswer: {
              '@type': FAQ_SCHEMA_ANSWER_TYPE,
              text: normalizeText(getAnswerText(item)),
            },
          })),
        }).replace(/</g, '\\u003c'),
      }}
    />
  );
}
